import { z } from 'zod';

export * as Auth from './bullhornAuthResponses.js';

export const EntityUpdate = z.looseObject({
  changedEntityType: z.string().nullish(),
  changedEntityId: z.number().or(z.string()),
  changeType: z.string(),
  data: z.looseObject({}).nullish(),
  messages: z
    .object({
      type: z.string(),
      detailMessage: z.string(),
      severity: z.string(),
    })
    .partial()
    .array()
    .nullish(),
});
export type EntityUpdate = z.infer<typeof EntityUpdate>;

export const AssociateEntity = EntityUpdate;
export type AssociateEntity = z.infer<typeof AssociateEntity>;

export const Search = z.object({
  count: z.number(),
  total: z.number(),
  data: z
    .looseObject({
      id: z.number().optional(),
      name: z.string().optional(),
    })
    .array(),
});
export type Search = z.infer<typeof Search>;
